// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import { Link } from '../../../internal/Button';
import logo from '../../../static/images/ansarada_logo_inline.png';
import logoSmall from '../../../static/images/ansarada-logo-symbol.svg';
import Hamburger from './Internal/Hamburger';
import MobileDrawer from './Internal/MobileDrawer';
import DesktopMenu from './Internal/DesktopMenu';
import type { CategoryType } from './Internal/types';

type LinkMenuType = {|
  name: string,
  link?: string,
  categories: Array<CategoryType>,
|};

type PropTypes = {|
  supportHref: string,
  loginHref: string,
  buyHref: string,
  linkMenu: Array<LinkMenuType>,
|};

/**
 * TODO: Remove this code when the board product uses ansarada id
 */

const isNoLogin = () => {
  if (global && global.location && global.location.pathname) {
    const addressPath = global.location.pathname.toLowerCase().replace(/\//g, '');
    switch (addressPath) {
      case 'board':
      case 'thedocyard':
      case 'quote':
      case 'quote-v2':
        return true;
      default:
        return false;
    }
  }
  return false;
};

const isNoTryNow = () => {
  if (global && global.location && global.location.pathname) {
    const pathNameLowerCase = global.location.pathname.toLowerCase();
    const addressPath = pathNameLowerCase.replace(/\//g, '');
    const isValidPath = [
      'tender-advisors',
      'tendergateway-review',
      'tenderpublic-sector-tender',
      'tenderprivate-sector-tender',
      'board',
      'thedocyard',
      'quote',
      'quote-v2',
      'microsoft-for-startups',
      'customerswappp',
    ].includes(addressPath);

    const isAdvisorsPricingPage = pathNameLowerCase.includes('/advisors-pricing/');
    const isCorporatePricingPage = pathNameLowerCase.includes('/advisors-pricing/');

    const isDataOverage = pathNameLowerCase.includes('/data-overages/');
    const isAdvisor = pathNameLowerCase.includes('type=advisor');
    const isValidDataOverage = isDataOverage && isAdvisor;

    return isValidPath || isValidDataOverage || isAdvisorsPricingPage || isCorporatePricingPage;
  }
  return false;
};

const LinkMenu = (props: LinkMenuType) => {
  return (
    <div className={styles.menuItem}>
      {props.categories.length === 0 ? (
        <button
          className={styles.menuTrigger}
          onClick={() => {
            window.location.href = props.link;
          }}
          type="button"
        >
          {props.name}
        </button>
      ) : (
        <>
          <button className={styles.menuTrigger}>{props.name}</button>
          <div className={styles.menuContainer}>
            <DesktopMenu categories={props.categories} />
          </div>
        </>
      )}
    </div>
  );
};

const Nav = (props: PropTypes) => {
  const [drawerOpen, onDrawerToggle] = React.useState(false);
  const [pageNoLogin, setPageNoLogin] = React.useState(false);
  const [noTryNow, setNoTrynow] = React.useState(false);

  React.useEffect(() => {
    setPageNoLogin(isNoLogin());
    setNoTrynow(isNoTryNow());
  }, []);

  React.useEffect(() => {
    if (drawerOpen && document.body) {
      document.body.classList.add(styles.overlay);
    }

    return function cleanup() {
      if (document.body) {
        document.body.classList.remove(styles.overlay);
      }
    };
  });

  return (
    <>
      <header className={styles.nav}>
        <nav className={styles.container}>
          <div className={styles.logo}>
            <a href="/">
              <img
                className={styles.desktopLogo}
                src={logo}
                alt="Ansarada"
                width="174"
                height="20"
              />
              <img
                className={styles.mobileLogo}
                src={logoSmall}
                alt="Ansarada"
                width="20"
                height="20"
              />
            </a>
          </div>
          <div className={styles.menuItemContainer}>
            {props.linkMenu.map((menuItem, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <LinkMenu {...menuItem} key={index} />
            ))}
          </div>
          <a href={props.supportHref} className={`${styles.link} ${styles.supportLink}`}>
            Support
          </a>
          {!pageNoLogin && (
            <a href={props.loginHref} className={styles.link}>
              Log in
            </a>
          )}
          {props.buyHref && !noTryNow ? (
            <Link
              href={props.buyHref}
              className={styles.button}
              size="Small"
              analyticsEvent={{
                event: 'f_website_try-now-for-free.clicked',
                properties: {
                  clicked_from: 'top_nav',
                },
              }}
            >
              Start for FREE
            </Link>
          ) : null}
          <Hamburger onClick={onDrawerToggle} active={drawerOpen} className={styles.hamburger} />
          {drawerOpen && (
            <div className={styles.mobileDrawer} data-testid="drawer">
              <MobileDrawer {...props} />
            </div>
          )}
        </nav>
      </header>
      <div className="header-after" id="header-after" />
    </>
  );
};

export default Nav;
